export const SSO_COOKIE_RESPONSE_KEY = 'SSOTOK';
